import { useState, useEffect } from 'react';
import { Tag } from 'antd';
import styled from 'styled-components';
import NativeNumber from '../../component/Numeral';

const StatusCountStyle = styled.div`
	& > * {
		padding: 7px 15px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
`;

interface StatusCount {
	cancelled: number;
	completed: number;
	pending: number;
	processing: number;
	review: number;
}
interface IStatusCount {
	statusCount: StatusCount;
}
const InvestmentWithdrawalStatusCount = ({ statusCount }: IStatusCount) => {
	const [counts, setCounts] = useState<any>({
		cancelled: 0,
		completed: 0,
		pending: 0,
		processing: 0,
		review: 0,
	});
	useEffect(() => {
		if (statusCount) {
			setCounts({
				cancelled: statusCount?.cancelled,
				completed: statusCount?.completed,
				pending: statusCount?.pending,
				processing: statusCount?.processing,
				review: statusCount?.review,
			});
		}
	}, [statusCount]);

	//  pending is usually ash color. approved, is green, review is brown. etc.. deleted is red.
	//  review, pending, processing, Completed, Cancelled
	return (
		<StatusCountStyle>
			<Tag color="yellow">
				<p>Review</p>
				<p>
					<NativeNumber value={counts.review} />
				</p>
			</Tag>
			<Tag color="orange">
				<p>Pending</p>
				<p>
					<NativeNumber value={counts.pending} />
				</p>
			</Tag>
			<Tag color="blue">
				<p>Processing</p>
				<p>
					<NativeNumber value={counts.processing} />
				</p>
			</Tag>
			<Tag color="green">
				<p>Completed</p>
				<p>
					<NativeNumber value={counts.completed} />
				</p>
			</Tag>
			<Tag color="gray">
				<p>Cancelled</p>
				<p>
					<NativeNumber value={counts.cancelled} />
				</p>
			</Tag>
		</StatusCountStyle>
	);
};

export default InvestmentWithdrawalStatusCount;
